import React, { FC } from "react";

import { OutlinedInput, makeStyles, OutlinedInputProps, Theme } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import { ArrowDropUp } from "@material-ui/icons";

import { Colors } from "../../styles";

type Props = OutlinedInputProps & {
    style?: React.CSSProperties;
    helperText?: string | null;
};

const useStyles = makeStyles({
    labledTextfieldLabel: {
        marginLeft: 20,
        Height: 28,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
});

const errorStyle = makeStyles(() => ({
    errorTextContainer: {
        position: "absolute",

        top: 71,
        left: 20,
        zIndex: 100,

        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 4,
        paddingBottom: 4,

        borderRadius: 4,

        backgroundColor: Colors.radiantRed,

        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.27,
        letterSpacing: "normal",
        color: Colors.white,
    },
}));

const useOutlinedInputStyles = makeStyles<Theme, { error: boolean }>({
    root: ({ error }) => ({
        marginTop: 7,
        borderRadius: 20,
        minHeight: 56,
        width: "100%",
        background: Colors.white,

        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
        color: Colors.anthracite,

        "& $notchedOutline": {
            borderColor: error ? Colors.radiantRed : Colors.anthracite25,
            borderWidth: error ? "2px" : "1px",
        },
        "&:hover $notchedOutline": {
            borderColor: error ? Colors.radiantRed : Colors.mellowYellow,
            borderWidth: error ? "2px" : "1px",
        },
        "&$focused $notchedOutline": {
            borderColor: error ? Colors.radiantRed : Colors.blueBright,
            borderWidth: error ? "2px" : "1px",
        },
        "&$focused": {
            //backgroundColor: Colors.eggshell,
        },
    }),
    focused: {},
    notchedOutline: {},

    input: {
        padding: 0,
    },
});

export const LabledMultilineTextField: FC<Props> = (props: Props) => {
    const { label, error, helperText, style } = props;
    const classes = useStyles();
    const outlinedInputClasses = useOutlinedInputStyles({ error: error || false });
    const errorClasses = errorStyle();

    return (
        <Grid item>
            <InputLabel className={classes.labledTextfieldLabel}>{label}</InputLabel>
            <div style={{ position: "relative" }}>
                <OutlinedInput
                    multiline={true}
                    labelWidth={0}
                    classes={outlinedInputClasses}
                    style={style}
                    {...props}
                />
                {error && (
                    <div>
                        <div style={{ position: "absolute", top: 58, left: 22 }}>
                            <ArrowDropUp style={{ color: Colors.radiantRed }}></ArrowDropUp>
                        </div>
                        <div className={errorClasses.errorTextContainer}>{helperText}</div>
                    </div>
                )}
            </div>
        </Grid>
    );
};
